import ERROR from "../symbols/error";

const initialState = {
  errorModalVisible: false,
  errorTitle: "",
  errorMessage: "",
};
const LOGIN_ERROR = 'Email address / password combination is incorrect';
function ErrorReducer(state = initialState, action: any) {
  switch (action.type) {
    case ERROR.SET_ERROR:
      return {
        ...state,
        errorModalVisible: true,
        errorTitle: action.payload === LOGIN_ERROR ? 'Invalid credentials' : "Error",
        errorMessage: action.payload,
      };
    case ERROR.CLEAR_ERROR:
      return {
        ...state,
        errorModalVisible: false,
        errorTitle: "",
        errorMessage: "",
      };

    default:
      return state;
  }
}

export default ErrorReducer;
